

import { createAction } from '@reduxjs/toolkit';


export const createAccountOTTERIACMRequest = createAction('CREATE_ACCOUNT_OTTERIACM_REQUEST', (username, emailId, brandId, brandName, aggregator) => {
    return {
        payload: {
            userName: username,
            emailId: emailId,
            brandId: brandId,
            brandName: brandName,
            aggregator: aggregator
          }
    }
});


export const createAccountOTTERIACMRequestSuccess = createAction('CREATE_ACCOUNT_OTTERIACM_REQUEST_SUCCESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const createAccountOTTERIACMRequestFailure = createAction('CREATE_ACCOUNT_OTTERIACM_REQUEST_FAILURE', data => {
    return {
        payload: {
            data
        }
    }
});

export const createCreateAccountOTTERIACMResponse = createAction('CLEARE_CREATE_ACCOUNT_OTTERIACM_RESPONSE', data => {
    return {
        payload: {
            data
        }
    }
});


export const createAdminRequest = createAction('CREATE_ACCOUNT_ADMIN_REQUEST', (username, emailId) => {
    return {
        payload: {
            userName: username,
            emailId: emailId,
          }
    }
});


export const createAdminRequestSuccess = createAction('CREATE_ACCOUNT_ADMIN_REQUEST_SUCCESS', data => {
    return {
        payload: {
            data
        }
    }
});

export const createAdminRequestFailure = createAction('CREATE_ACCOUNT_ADMIN_REQUEST_FAILURE', data => {
    return {
        payload: {
            data
        }
    }
});

export const clearCreateAdminRequestResponse = createAction('CLEAR_CREATE_ACCOUNT_ADMIN_RESPONSE', data => {
    return {
        payload: {
            data
        }
    }
});